import IntroductionTransition from './IntroductionTransition';

export default IntroductionTransition;
